import * as types from '../types'
import {NOTIFICATION_DEFAULT_TIMEOUT, NOTIFICATION_DEFAULT_COLOR} from '../../config.js';
import * as globalApi from '../../api/core/global.dd'

const state = {
  showNotification: null,
  showSideMenu:{
    show: true
  },
  globalNotifications:[],
  currentBreadcrumbs: [{text: 'Home', disabled: true}],
  hideBreadcrumb: false,
  fsLoading: false,
  topbarDense: false,
  globalSearchTerm: '',
  backgroundIcon: null,
  dashboardStats:[],
  timeTables:[],
  systemMessages: [],
  systemMessagesMeta: null,
  overalSystemMessagesMeta: null,
  userMessagesMeta: null,
  userMessages: []
}

const getters = {
  [types.SYSTEM_MESSAGES]: (state) => {
    return state.systemMessages
  },  
  [types.SYSTEM_MESSAGES_META]: (state) => {
    return state.systemMessagesMeta
  },  
  [types.USER_MESSAGES_META]: (state) => {
    return state.userMessagesMeta
  },  
  [types.USER_MESSAGES]: (state) => {
    return state.userMessages
  }, 
  [types.OVERAL_SYSTEM_MESSAGES_META]: (state) => {
    return state.overalSystemMessagesMeta
  },  
  [types.GLOBAL_NOTIFICATIONS]: (state) => {
    return state.globalNotifications
  },  
  [types.SHOW_NOTIFICATION]: (state) => {
    return state.showNotification
  },
  [types.TIME_TABLES]: (state) => {
    return state.timeTables
  },
  [types.DASHBOARD_STATS]: (state) => {
    return state.dashboardStats
  },  
  [types.MAIN_MENU_SHOWN]: (state) => {
    return state.showSideMenu
  },
  [types.CURRENT_BREADCRUMBS]: (state) => {
    return state.currentBreadcrumbs
  },
  [types.HIDE_BREADCRUMBS]: (state) => {
    return state.hideBreadcrumb
  },
  [types.FS_LOADING]: (state) => {
    return state.fsLoading
  },
  [types.TOPBAR_DENSE]: (state) => {
    return state.topbarDense
  },
  [types.GLOBAL_SEARCH_TERM]: (state) => {
    return state.globalSearchTerm
  },
  [types.BACKGROUND_ICON]: (state) => {
    return state.backgroundIcon
  },
}

const mutations = {
  [types.ADD_GLOBAL_NOTIFICATIONS]: (state, payload) => {
    payload.seen = false
    payload.key = state.globalNotifications.length + 1
    state.globalNotifications.unshift(payload)
  },  
  [types.NOTIFICATION_SEEN]: (state, payload) => {
    // uses the key attribute
    let index = state.globalNotifications.findIndex(item => item.key === payload)    
    if(index != -1){
      state.globalNotifications[index].seen = true;
      
    }    
  },  
  [types.REMOVE_GLOBAL_NOTIFICATIONS]: (state, payload) => {
    let arr = []
    state.globalNotifications.forEach((item) => {
        if(item != payload){
          arr.push(item)
        }
    })
    state.globalNotifications = arr
  }, 
  [types.SYSTEM_MESSAGES]: (state, payload) => {
    state.systemMessages = payload.data
    state.systemMessagesMeta = payload.meta
  }, 
  [types.APPLICATION_SYSTEM_MESSAGES]: (state, payload) => {
    state.systemMessages = payload.data
    state.systemMessagesMeta = payload.meta
  },  
  [types.OVERAL_SYSTEM_MESSAGES_META]: (state, payload) => {    
    state.overalSystemMessagesMeta = payload
  },  
  [types.USER_MESSAGES_META]: (state, payload) => {    
    state.userMessagesMeta = payload
  },   
  [types.USER_MESSAGES]: (state, payload) => {    
    state.userMessages = payload
  },    
  [types.ADD_USER_MESSAGE]: (state, payload) => {    
    state.userMessages.push(payload)
  },     
  [types.CLEAR_GLOBAL_NOTIFICATIONS]: (state, payload) => {
    state.globalNotifications = payload
  },  
  [types.SHOW_NOTIFICATION]: (state, payload) => {
    state.showNotification = payload;
  },
  [types.TIME_TABLES]: (state, payload) => {
    state.timeTables = payload;
  },
  [types.DASHBOARD_STATS]: (state, payload) => {
    state.dashboardStats = payload;
  },
  [types.MAIN_MENU_SHOWN]: (state, payload) => {
    state.showSideMenu = payload;
  },
  [types.CURRENT_BREADCRUMBS]: (state, payload) => {
    state.currentBreadcrumbs = payload;
  },
  [types.HIDE_BREADCRUMBS]: (state, payload) => {
    state.hideBreadcrumb = payload;
  },
  [types.FS_LOADING]: (state, payload) => {
    state.fsLoading = payload;
  },
  [types.TOPBAR_DENSE]: (state, payload) => {
    state.topbarDense = payload;
  },
  [types.GLOBAL_SEARCH_TERM]: (state, payload) => {
    state.globalSearchTerm = payload;
  },
  [types.BACKGROUND_ICON]: (state, payload) => {
    state.backgroundIcon = payload;
  }
}

const actions = {
  [types.ADD_GLOBAL_NOTIFICATIONS]: ( {commit}, payload) => {
    commit(types.ADD_GLOBAL_NOTIFICATIONS, payload)             
  },   
  [types.REMOVE_GLOBAL_NOTIFICATIONS]: ( {commit}, payload) => {
    commit(types.REMOVE_GLOBAL_NOTIFICATIONS, payload)             
  }, 
  [types.CLEAR_GLOBAL_NOTIFICATIONS]: ( {commit}) => {
    commit(types.CLEAR_GLOBAL_NOTIFICATIONS, [])             
  },     
  [types.NOTIFICATION_SEEN]: ( {commit}, payload) => {
    commit(types.NOTIFICATION_SEEN, payload);
  },   
  [types.SYSTEM_MESSAGES]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getSystemMessages(payload.data, payload.params).then((res) => {                                             
          commit(types.SYSTEM_MESSAGES, res)
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },
  [types.APPLICATION_SYSTEM_MESSAGES]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getApplicationSystemMessages(payload.data, payload.params).then((res) => {                                             
          commit(types.APPLICATION_SYSTEM_MESSAGES, res)
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },
  [types.OVERAL_SYSTEM_MESSAGES_META]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getOveralSystemMessagesMeta(payload.data, payload.params).then((res) => {                                             
          commit(types.OVERAL_SYSTEM_MESSAGES_META, res.data)
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },
  [types.USER_MESSAGES_META]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getUserMessagesMeta(payload.data, payload.params).then((res) => {                                             
          commit(types.USER_MESSAGES_META, res.data)
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },
  [types.USER_MESSAGES]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getUserMessages(payload.data, payload.params).then((res) => {                                             
          commit(types.USER_MESSAGES, res.data)
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },
  [types.SEND_USER_MESSAGE]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.sendUserMessage(payload.data, payload.params).then((res) => {                                             
          commit(types.ADD_USER_MESSAGE, res.data)
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },
  [types.SHOW_NOTIFICATION]: ( {commit}, payload) => {
    // set default values if options not given
    if(!payload.options){
        payload.options = {timeout: NOTIFICATION_DEFAULT_TIMEOUT, color: NOTIFICATION_DEFAULT_COLOR};
    }
    // set default timeout value if not given
    else if(!payload.options.timeout){
        payload.options.timeout = NOTIFICATION_DEFAULT_TIMEOUT;
    }
    // set default color if not given
    else if(!payload.options.color){
      payload.options.color = NOTIFICATION_DEFAULT_COLOR;
    }
    // now commit payload and remove it after given timeout
    commit(types.SHOW_NOTIFICATION, payload);
    setTimeout(()=>{
      commit(types.SHOW_NOTIFICATION, null);
    }, payload.options.timeout );
  },
  [types.DASHBOARD_STATS]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getDashboardStats(payload.data, payload.params).then((res) => {                 
                 
          commit(types.DASHBOARD_STATS, res.data)                   
          resolve(res.data)
      }).catch((e) => {
        reject(e.result)
      })
    })
    return p
  },  
  [types.HARDWARE_PRESETS]: ( {commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getHardwareEventPresets(payload.data, payload.params).then((res) => {                                             
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },    
  [types.TIME_TABLES]: ({commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.getTimeTables(payload.data, payload.params).then((res) => {    

          commit(types.TIME_TABLES, res.data)                                 
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },  
  [types.SAVE_TIME_TABLE]: ({commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.saveTimeTable(payload.data, payload.params).then((res) => {                                 
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },    
  [types.DELETE_TIME_TABLE]: ({commit}, payload) => {
    let p = new Promise((resolve, reject) => {     
      globalApi.deleteTimeTable(payload.data, payload.params).then((res) => {                                 
          resolve(res)
      }).catch((e) => {
        reject(null)
      })
    })
    return p
  },      
  [types.MAIN_MENU_SHOWN]: ( {commit}, payload) => {
    commit(types.MAIN_MENU_SHOWN, payload);
  },
  [types.CURRENT_BREADCRUMBS]: ( {commit}, payload) => {

    commit(types.CURRENT_BREADCRUMBS, payload);
  },
  [types.HIDE_BREADCRUMBS]: ( {commit}, payload) => {

    commit(types.HIDE_BREADCRUMBS, payload);
  },
  [types.FS_LOADING]: ( {commit}, payload) => {

    commit(types.FS_LOADING, payload);
  },
  [types.TOPBAR_DENSE]: ( {commit}, payload) => {
    commit(types.TOPBAR_DENSE, payload);
  },
  [types.GLOBAL_SEARCH_TERM]: ( {commit}, payload) => {
    commit(types.GLOBAL_SEARCH_TERM, payload);
  },
  [types.BACKGROUND_ICON]: ( {commit}, payload) => {
    commit(types.BACKGROUND_ICON, payload);
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
